export class User {
    AccountCreatedFlag: boolean;
    UserID: string;
    OwnerID: number;
    CustomerID: number;
    EmailAddress: string;
    FirstName: string;
    MiddleName: string;
    LastName: string;
    MobileNumber: string;
    StateDropdown?: { Abbreviation: string , Description: string, Selected: boolean }[]; 
    CountryDropdown?: { Abbreviation: string, Description: string, Selected: boolean }[];
    AutoLoggedIn?: boolean;
    UpdateFlag?: boolean;
    UpdateText?: string;
}

export class UserCreate extends User {
    Password: string;
}

export class UserNotification {
    NotificationID: number;
    SponsorID: number;
    TeamLogo: string;
    CreationDate: string;
    ReadDate?: string;
    Title: string;
    Content: string;
    URLPageName: string;
    URLPageParms?: string;
    DeleteFlag: boolean;
}

export class PasswordPostObject {
    NewPassword: string;
    OldPassword: string;
    UserID: string;
}

export class TempPassObject {
    Email: string = "";
}

export class NotificationToken {
    Token?: string = "";
    EmailAddress?: string = "";
    //OS?: string = "";
    Product?: string = "";
    Version?: string = "";
    Device?: DeviceInfo;
}

export class DeviceInfo {
    cordova?: string = "";
    model?: string = "";
    platform?: string = "";
    uuid?: string = "";
    version?: string = "";
    manufacturer?: string = "";
    isVirtual?: boolean;
    serial?: string = "";
}

export class AccountAvailableActions {
    AccountLocked: boolean | null;
    HasBalanceDue: boolean | null;
    HasOnHold: boolean | null;
    Messages: string;
    ShowDonate: boolean | null;
    ShowExchange: boolean | null;
    ShowMobile: boolean | null;
    ShowPasses: boolean | null;
    ShowPrint: boolean | null;
    ShowGateValidate: boolean | null;
    ShowReclaim: boolean | null;
    ShowResell: boolean | null;
    ShowTransfer: boolean | null;
    ShowText: boolean | null;
}

export class UserUpdateInfo {
    AccountType?: string = "";
    Address1?: string = "";
    Address2?: string = "";
    City?: string = "";
    CorpName?: string = "";
    EmailAddress?: string = "";
    EmailOptOut?: boolean = false;
    FirstName?: string = "";
    GuestCustomerID?: number = null;
    LastName?: string = "";
    MiddleName?: string = "";
    Phone?: string = "";
    PostalCode?: string = "";
    State?: string = "";
    Country?: string = "";
    StateOther?: string = "";
}



// WEBPACK FOOTER //
// ./src/services/account/account.model.ts